export class ValidationHelper {
// eslint-disable-next-line sonarjs/public-static-readonly
    static isEmpty = value => value == null || value === undefined || value === "";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static isNotEmpty = value => !ValidationHelper.isEmpty(value);
}
